import { FormControl, Grid, TextField, Button } from '@material-ui/core'
import React from 'react'
import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
    menuControlName: yup
        .string('Enter your Name menu')
        .required('Name menu is required'),
    menuControlPart: yup
        .string('Enter your Part url')
        .required('Part url is required'),
    menuControlIcon: yup
        .string('Enter your part Icon')
        .required('Icon is required'),
    menuControlMainSub: yup
        .string('Enter your part Main or sub')
        .required('Main or sub is required'),
    menuControlIndex: yup
        .string('Enter your part Index')
        .required('Index is required'),
});
      


function FormCreateMenu({BtnTitle="Submit", handleSubmit = ()=>{}, dataInitial={menuControlName: '', menuControlPart: '', menuControlIcon: '', menuControlMainSub: 0, menuControlIndex: 0}}) {
    const formik = useFormik({
        initialValues: dataInitial,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values)
        },
    });
    return (
    <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
            <Grid item xs={12} md={6} lg={4}>
                <FormControl className="t-form-group-custom mb-10" >
                    <TextField
                        fullWidth
                        id="menuControlName"
                        name="menuControlName"
                        label="Name menu"
                        variant="outlined"
                        size="small"
                        value={formik.values.menuControlName}
                        onChange={formik.handleChange}
                        error={formik.touched.menuControlName && Boolean(formik.errors.menuControlName)}
                        helperText={formik.touched.menuControlName && formik.errors.menuControlName}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <FormControl className="t-form-group-custom mb-10" >
                    <TextField
                        fullWidth
                        id="menuControlPart"
                        name="menuControlPart"
                        label="Part menu"
                        variant="outlined"
                        size="small"
                        value={formik.values.menuControlPart}
                        onChange={formik.handleChange}
                        error={formik.touched.menuControlPart && Boolean(formik.errors.menuControlPart)}
                        helperText={formik.touched.menuControlPart && formik.errors.menuControlPart}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <FormControl className="t-form-group-custom mb-10" >
                    <TextField
                        fullWidth
                        id="menuControlIcon"
                        name="menuControlIcon"
                        label="Icon menu"
                        variant="outlined"
                        size="small"
                        value={formik.values.menuControlIcon}
                        onChange={formik.handleChange}
                        error={formik.touched.menuControlIcon && Boolean(formik.errors.menuControlIcon)}
                        helperText={formik.touched.menuControlIcon && formik.errors.menuControlIcon}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <FormControl className="t-form-group-custom mb-10" >
                    <TextField
                        fullWidth
                        id="menuControlMainSub"
                        name="menuControlMainSub"
                        label="Main or Sub menu"
                        variant="outlined"
                        size="small"
                        value={formik.values.menuControlMainSub}
                        onChange={formik.handleChange}
                        error={formik.touched.menuControlMainSub && Boolean(formik.errors.menuControlMainSub)}
                        helperText={formik.touched.menuControlMainSub && formik.errors.menuControlMainSub}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <FormControl className="t-form-group-custom mb-10" >
                    <TextField
                        fullWidth
                        id="menuControlIndex"
                        name="menuControlIndex"
                        label="Index menu"
                        variant="outlined"
                        size="small"
                        value={formik.values.menuControlIndex}
                        onChange={formik.handleChange}
                        error={formik.touched.menuControlIndex && Boolean(formik.errors.menuControlIndex)}
                        helperText={formik.touched.menuControlIndex && formik.errors.menuControlIndex}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <Button className='btn t-btn-primary' variant="contained" type="submit">
                    {BtnTitle}
                </Button>
            </Grid>
        </Grid>
    </form>
    )
}

export default FormCreateMenu